import axios from 'axios';

const getBookAppointmentInformation = (controller, queryParams) => {
  const url = `/${controller}/book_appointment_detail`;
  return axios.get(url, {
    params: queryParams,
  });
};

// eslint-disable-next-line import/prefer-default-export
export { getBookAppointmentInformation };
